import * as React from 'react';
import { Link } from 'react-router-dom';
import { getPartyById, getCandidateById, canEditPartyText, canEditCandidateText } from '../../selectors';
import { getTranslator } from '../../Translator';
import { useAppSelector } from '../../hooks';

type EditOptionsProps = {
    candidateId: number;
}

export const EditOptions = (props: EditOptionsProps) => {
    const candidateId = props.candidateId;
    const language = useAppSelector(state => state.language);
    const account = useAppSelector(state => state.clientState.Account);
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);

    const t = getTranslator(language);

    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const isPartyAdmin = party.IsCurrentAccountPartyAdmin;
    const isPartyEditable = canEditPartyText(account, parties, elections, candidate.PartyId);
    const isCandidateEditable = canEditCandidateText(account, candidates, parties, elections, candidateId);

    const showEditButton = account.IsAdmin || isPartyAdmin || candidate.IsCurrentAccountCandidate;
    const allowEditing = isPartyEditable || isCandidateEditable;

    if (allowEditing) {
        return <Link className="linkbutton" to={`/candidateEdit/${candidateId}`}>{t['Edit']}</Link>;
    } else if (showEditButton) {
        return <span className="linkbutton linkbutton--disabled">{t['Edit']}</span>;
    } else {
        return null;
    }
}
